
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'About', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="bg-gray-900 shadow-lg sticky top-0 z-50">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-8">
        <div className="flex lg:flex-1">
          <Link to="/" className="cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/98a462c0b3cf6817d49a825bf36d1d13/7f61d7ef13f2d26ba835b52d0afd2fac.png" 
              alt="Ugo Frederick" 
              className="h-10 w-auto"
            />
          </Link>
        </div>
        
        <button
          type="button"
          className="lg:hidden p-2 cursor-pointer"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-300`}></i>
        </button>

        <div className="hidden lg:flex lg:gap-x-8">
          {navigation.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`text-sm font-semibold whitespace-nowrap transition-colors cursor-pointer ${
                isActive(item.href)
                  ? 'text-teal-500'
                  : 'text-gray-300 hover:text-teal-500'
              }`}
            >
              {item.name}
            </Link>
          ))}
        </div>

        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <Link
            to="/client-portal"
            className="text-sm font-semibold text-white bg-teal-600 px-6 py-2.5 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Client Portal
          </Link>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-gray-800 border-t border-gray-700">
          <div className="px-6 py-4 space-y-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`block px-3 py-2 text-base font-semibold rounded-lg cursor-pointer ${
                  isActive(item.href)
                    ? 'text-teal-500 bg-gray-700'
                    : 'text-gray-300 hover:bg-gray-700'
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/client-portal"
              className="block text-center text-base font-semibold text-white bg-teal-600 px-3 py-2 rounded-lg hover:bg-teal-700 transition-colors cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              Client Portal
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
